import { render, staticRenderFns } from "./StaticContactUs.vue?vue&type=template&id=6786ac7f&scoped=true&"
import script from "./StaticContactUs.vue?vue&type=script&lang=js&"
export * from "./StaticContactUs.vue?vue&type=script&lang=js&"
import style0 from "./StaticContactUs.vue?vue&type=style&index=0&id=6786ac7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6786ac7f",
  null
  
)

export default component.exports